<template>
  <div class="clients">
    <div class="sort_type">
      <select id="sort_type" v-model="sort">
        <option value="new">Новые</option>
        <option value="old">Старые</option>
        <option value="is_auth">Авторизованные</option>
        <option value="not_auth">Не авторизованные</option>
        <option value="canceled_month">Отмен броней за месяц</option>
        <option value="canceled_all">Отмен броней за все время</option>
      </select>
    </div>
    <div class="clients__body">
      <a>
        <div class="clients__item" :class="{active: item.isActive}" :key="idx" v-for="(item, idx) in masters"
             @click="$emit('activeMaster', idx, item)">
          <div class="clients__item-logo" :style="{background: `url(${item.avatar})`}">
            <!--            <img :src="item.avatar" alt="" height="50px" style="border-radius: 50%;border: 1px solid #DBBFA7; object-fit: cover;">-->
          </div>
          <div class="clients__item-top">
            <div class="clients__item-top-user">
              <div style="display: flex;align-items: center;">
                <div class="clients__item-fullname">{{ getName(item) }}</div>
                <div class="red" v-if="!item.authorized_at"></div>
              </div>
              <div>
                <div class="clients__item-date">{{ item.created_at }}</div>
              </div>
            </div>
            <div style="display: flex;align-items: center;justify-content: space-between;flex-wrap: wrap">
              <div class="clients__item-body">
                <p>{{ item.phone }}</p>
              </div>
              <div class="vacation" v-if="item.vacation && item.frozen.length">Заморожен</div>
            </div>
          </div>
        </div>
      </a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MastersList',
  props: {
    masters: Array,
  },
  data() {
    return {
      sort: "new",
      payload: {
        field: null,
        direction: null,
      }
    }
  },
  watch: {
    sort(to) {
      this.$emit('change', this.getSortPayload(to));
    }
  },
  methods: {
    getName(master) {
      return master.name || master.surname ? (master.name || '') + ' ' + (master.surname || '') : 'Не указанно';
    },
    getSortPayload(sort) {
      switch (sort) {
        case "new":
          return {field: 'id', direction: 'desc'};
        case "old":
          return {field: 'id', direction: 'asc'};
        case "is_auth":
          return {field: 'authorized_at', direction: 'desc'};
        case "not_auth":
          return {field: 'authorized_at', direction: 'asc'};
        case "canceled_month":
          return {field: 'rents_count', direction: 'desc', month: true};
        case "canceled_all":
          return {field: 'rents_count', direction: 'desc'};
        default:
          return {field: 'id', direction: 'desc'};
      }
    }
  }
}

</script>

<style scoped lang="scss">
.vacation {
  color: #bb0f0f;
  font-weight: bold;
  font-size: 14px;
}

.red {
  height: 10px;
  width: 10px;
  background: #bb0f0f;
  border-radius: 50%;
  margin-left: 10px;
}

.sort_type {
  margin-left: 20px;
  margin-bottom: 20px;

  label {
    font-size: 16px;
    display: block;
    margin-bottom: 5px;
  }

  select {
    position: relative;
    border: 1px solid #DBBFA7;
    box-sizing: border-box;
    border-radius: 5px;
    height: 30px;
    cursor: pointer;
    padding-left: 10px;
    padding-right: 10px;
    background-color: transparent;
    font-size: 16px;
    color: #383838;
    z-index: 2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-family: "Open Sans", sans-serif;
  }
}

.clients {
  background-color: #fff;
  padding: 0 0;

  &__item {
    padding: 10px 15px;
    border-bottom: 1px solid #E5E5E5;
    display: flex;

    &.active {
      color: #383838;
      background-color: rgba(219, 191, 167, 0.3);

      &:hover {
        opacity: 1;
      }
    }

    &-top {
      width: calc(100% - 70px);

      &-user {
        display: flex;
        justify-content: space-between;
        align-items: center;
      }
    }

    &-fullname {
      font-weight: 600;
      font-size: 16px;
      color: #383838;
    }

    &-date {
      line-height: 24px;
      font-size: 14px;
      color: #808080;
    }

    &-logo {
      border: 1px solid #DBBFA7;
      border-radius: 50%;
      width: 50px;
      height: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
      background-position: center !important;
      background-size: cover !important;
    }

    &-body {
      font-style: normal;
      font-weight: normal;
      font-size: 16px;
      line-height: 24px;
      color: #808080;

      p {
        // width: 300px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

@media screen and (max-width: 1170px) {
  .clients__item-date {
    display: none;
  }
}
</style>
